import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./features/login/login.component').then(m => m.LoginComponent),
    },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
            },
            // -- Master --
            {
                path: 'slider',
                loadComponent: () => import('./features/slider/slider.component').then(m => m.SliderComponent),
            },
            {
                path: 'website-home',
                loadComponent: () => import('./features/website-home/website-home.component').then(m => m.WebsiteHomeComponent),
            },
            {
                path: 'order-statuses',
                loadComponent: () => import('./features/order-statuses/order-statuses.component').then(m => m.OrderStatusesComponent),
            },
            // -- Catalogue --
            {
                path: 'products',
                loadComponent: () => import('./features/products/products.component').then(m => m.ProductsComponent),
            },
            {
                path: 'brands',
                loadComponent: () => import('./features/brands/brands.component').then(m => m.BrandsComponent),
            },
            {
                path: 'categories',
                loadComponent: () => import('./features/categories/categories.component').then(m => m.CategoriesComponent),
            },
            // -- Orders --
            {
                path: 'orders',
                loadComponent: () => import('./features/orders/orders.component').then(m => m.OrdersComponent),
            },
            {
                path: 'payments',
                loadComponent: () => import('./features/payments/payments.component').then(m => m.PaymentsComponent),
            },
            // -- Customers --
            {
                path: 'customers',
                loadComponent: () => import('./features/customers/customers.component').then(m => m.CustomersComponent),
            },
            // -- Marketing --
            {
                path: 'coupons',
                loadComponent: () => import('./features/coupons/coupons.component').then(m => m.CouponsComponent),
            },
            {
                path: 'shipping-rules',
                loadComponent: () => import('./features/shipping-rules/shipping-rules.component').then(m => m.ShippingRulesComponent),
            },
            // -- Content --
            {
                path: 'reviews',
                loadComponent: () => import('./features/reviews/reviews.component').then(m => m.ReviewsComponent),
            },
            {
                path: 'faqs',
                loadComponent: () => import('./features/faqs/faqs.component').then(m => m.FaqsComponent),
            },
            {
                path: 'contact-enquiries',
                loadComponent: () => import('./features/contact-enquiries/contact-enquiries.component').then(m => m.ContactEnquiriesComponent),
            },
            {
                path: 'static-pages',
                loadComponent: () => import('./features/static-pages/static-pages.component').then(m => m.StaticPagesComponent),
            },
            {
                path: 'brands-page',
                loadComponent: () => import('./features/brands-page/brands-page.component').then(m => m.BrandsPageComponent),
            },
            {
                path: 'about-page',
                loadComponent: () => import('./features/about-page/about-page.component').then(m => m.AboutPageComponent),
            },
            // -- Reports --
            {
                path: 'reports',
                loadComponent: () => import('./features/reports/reports.component').then(m => m.ReportsComponent),
            },
            // -- Administration --
            {
                path: 'admin-users',
                loadComponent: () => import('./features/admin-users/admin-users.component').then(m => m.AdminUsersComponent),
            },
            {
                path: 'settings',
                loadComponent: () => import('./features/settings/settings.component').then(m => m.SettingsComponent),
            },
            // -- Fallback --
            { path: '**', redirectTo: 'dashboard' },
        ],
    },
    { path: '**', redirectTo: 'login' },
];
